import { ThunkType } from "../../../../../core/store/reducers";
import { setData } from "../tradeByClientsDataSlice";
import getTradeByClientsDataApi from "../api/getTradeByClientsData";

export const loadReport = (): ThunkType => async (dispatch, getStore) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const user = store.data.auth.current.user;
  const { filter } = store.ux.reports.exchbusiness.tradeByClients;

  const pagedTrades = await dispatch(getTradeByClientsDataApi(user, filter));

  dispatch(setData(pagedTrades || []));
};
